import React from 'react';

import PropTypes from 'prop-types';

import {useDispatch, useSelector} from 'react-redux';
import {Navigate, useNavigate} from 'react-router-dom';


import {Box, Center, Stack} from '@mantine/core';

import RecordForm from '../forms/RecordForm';

import {updateTermsOfUseAcceptance} from '../reducers/recordsSlice';

import {useAuth} from 'hooks/useAuth';

import panasonicLogo from 'assets/images/panasonic-logo.png';

import TermsOfUseDocument from '../components/TermsOfUseDocument';

import {useAccount} from 'hooks/useAccount';

import {userAgreementResultSelector} from '../selectors';

import {ActivityIndicator} from 'components/ActivityIndicator';

const AcceptTermsAndConditionsComponent = ({handleFormSubmit}) => (
    <Center>
        <Stack>
            <Box padding="xxl">
                <img src={panasonicLogo} alt="Panasonic Avionics"/>
            </Box>
            <Box className="terms-conditions-modal">
                <TermsOfUseDocument handleFormSubmit={handleFormSubmit}/>
            </Box>
        </Stack>
    </Center>
);

export const AcceptancePage = () => {
    const account = useAccount();

    const {user, profile, session} = useAuth({account});

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const userAgreementResult = useSelector((state) =>
                                                userAgreementResultSelector(state)
    );

    const handleCancel = () => {
        return navigate('/');
    };

    const handleSubmit = (values) => {
        dispatch(updateTermsOfUseAcceptance(profile));
        navigate(`/redirect/${account.id}`);
    };

    if (account === null) {
        //return <Navigate to="/404" />;
        return <ActivityIndicator label="Loading acconut...Please wait!"/>;
    }

    if (
        typeof userAgreementResult !== 'undefined' &&
        userAgreementResult !== null
    ) {
        if (userAgreementResult === 'success') {
            return <Navigate to={`/redirect/${account.id}`}/>;
        }
    }

    return (
        <RecordForm handleSubmit={handleSubmit} handleCancel={handleCancel}/>
    );
};

AcceptTermsAndConditionsComponent.propTypes = {
    handleFormSubmit: PropTypes.func,
};
